import { useEffect, useState } from 'react'
import { RouterProvider } from 'react-router-dom'

import { DomainProvider } from '@/contexts/DomainContext'

import { PageLoading } from './components/PageLoading'
import { router } from './router'
import { useUserStore } from './stores/user'
import { getToken } from './utils/auth'

export default function App() {
  const [loading, setLoading] = useState(true)

  const userStore = useUserStore()

  useEffect(() => {
    const intervalId = setInterval(() => {
      const token = getToken()
      if (token) {
        userStore.getAccount()
      }
    }, 5000)

    return () => clearInterval(intervalId)
  }, [userStore])

  useEffect(() => {
    Promise.all([userStore.getUserInfo(), userStore.getAccount()]).finally(() => {
      setLoading(false)
    })
  }, [])

  return (
    <DomainProvider>
      {loading ? <PageLoading /> : <RouterProvider router={router} />}
    </DomainProvider>
  )
}
